import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  showDialog: false,
  isLoading: false,
  bidTypesList: [],
  bidStatusList: [],
  bidCategoriesList: [],
};

//STORE SLICE
export const bidsAddSlice = createSlice({
  name: "bidsAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddBidDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    closeAddBidDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    }, 
  },
});

//ACTIONS
export const {
  showAddBidDialog,
  closeAddBidDialog,
  showLoading,
  hideLoading,
} = bidsAddSlice.actions;

export default bidsAddSlice.reducer;
